module.exports = __webpack_public_path__ + "static/book-marketer-left.8df7c25f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/book-marketer-left.png
// module id = 1469
// module chunks = 168707334958949